<template>
  <div class=" order role-page ">
    <top-bar :title="i18n.t('financeBuy.role3')"  @back="back"></top-bar>

    <div class="notice-list">
      <div class="list" >
        <div class="content">
          <div class="detail">{{$t('financeBuy.content1')}}</div>
          <div class="detail">{{$t('financeBuy.content2')}}</div>
          <div class="detail">{{$t('financeBuy.content3')}}</div>
          <div class="detail">{{$t('financeBuy.content4')}}</div>
          <div class="detail">{{$t('financeBuy.content5')}}</div>
          <div class="detail">{{$t('financeBuy.content6')}}</div>
          <div class="detail">{{$t('financeBuy.content7')}}</div>
          <div class="detail">{{$t('financeBuy.content8')}}</div>
          <div class="detail">{{$t('financeBuy.content9')}}</div>
          <div class="detail">{{$t('financeBuy.content10')}}</div>
          <div class="detail">{{$t('financeBuy.content11')}}</div>
          <div class="detail">{{$t('financeBuy.content12')}}</div>
          <div class="detail">{{$t('financeBuy.content13')}}</div>
          <div class="detail">{{$t('financeBuy.content14')}}</div>
          <div class="detail">{{$t('financeBuy.content15')}}</div>
          <div class="detail">{{$t('financeBuy.content16')}}</div>
          <div class="detail">{{$t('financeBuy.content17')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  props: {
    roleData: Object
  },
  data() {
    return {
      
    }
  },
  mounted() {
  },
  methods: {
    back() {
      this.$emit('cancel')
    }
  }
}
</script>